module.exports = __webpack_public_path__ + "static/img/body_bg.4f51d45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/body_bg.jpg
// module id = ZZTO
// module chunks = 9